var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oeamtc-inputwrap"},[(_vm.prefix)?_c('div',{staticClass:"oeamtc-padding--small"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_vm._t("default"),(_vm.suffix)?_c('div',{staticClass:"oeamtc-inputwrap__suffix"},[_vm._v(_vm._s(_vm.suffix))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }